<template>
    <div :class="[
            type === 'textarea' ? 'el-textarea' : 'el-input',
            size ? 'el-input-' + size : '',
            {
                'is-disabled': disabled,
                'el-input-group': $slots.prepend || $slots.append,
                'el-input-group-append': $slots.append,
                'el-input-group-prepend': $slots.prepend
            }
        ]">
        <template v-if="type !== 'textarea'">
            <!-- 前置元素 -->
            <div class="el-input-group-prepend" v-if="$slots.prepend">
                <slot name="prepend"></slot>
            </div>
            <!-- input 图标 -->
            <slot name="icon">
                <i class="el-input-icon" :class="[icon ? 'el-icon-' + icon : '']" v-if="icon" @click="handleIconClick"></i>
            </slot>
            <input
                    v-if="type !== 'textarea'"
                    class="el-input-inner"
                    :type="type"
                    :name="name"
                    :placeholder="placeholder"
                    :disabled="disabled"
                    :readonly="readonly"
                    :maxlength="maxlength"
                    :minlength="minlength"
                    :autocomplete="autoComplete"
                    :autofocus="autofocus"
                    :min="min"
                    :max="max"
                    :form="form"
                    :value="currentValue"
                    ref="input"
                    @input="handleInput"
                    @focus="handleFocus"
                    @blur="handleBlur"
                    @keyup.enter="handleEnter"
            >
            <i class="el-input-icon el-icon-loading" v-if="validating"></i>
            <!-- 后置元素 -->
            <div class="el-input-group-append" v-if="$slots.append">
                <slot name="append"></slot>
            </div>
        </template>
        <textarea
                v-else
                class="el-textarea-inner"
                :value="currentValue"
                ref="textarea"
                :name="name"
                :placeholder="placeholder"
                :disabled="disabled"
                :style="textareaStyle"
                :readonly="readonly"
                :rows="rows"
                :form="form"
                :autofocus="autofocus"
                :maxlength="maxlength"
                :minlength="minlength"
                @input="handleInput"
                @focus="handleFocus"
                @blur="handleBlur">
    </textarea>
    </div>
</template>
<script>
    import emitter from '../../../utils/emitter';
    import calcTextareaHeight from './calcTextareaHeight';

    export default {
        name: 'ElInput',

        componentName: 'ElInput',

        mixins: [emitter],

        data(){
            return {
                currentValue:this.value,
                textareaStyle:{}
            }
        },

        props: {
            value: [String, Number],
            placeholder: String,
            size: String,
            resize:String,
            readonly: Boolean,
            autofocus: Boolean,
            icon: String,
            disabled: Boolean,
            type: {
                type: String,
                default: 'text'
            },
            name: String,
            autosize: {
                type: [Boolean, Object],
                default: false
            },
            rows: {
                type: Number,
                default: 2
            },
            autoComplete: {
                type: String,
                default: 'off'
            },
            form: String,
            maxlength: Number,
            minlength: Number,
            max: {},
            min: {},
            validateEvent: {
                type: Boolean,
                default: true
            },
            onIconClick: Function
        },

        computed: {
            validating() {
                return this.$parent.validateState === 'validating';
            }
        },

        watch: {
            'value'(val, oldValue) {
                this.setCurrentValue(val);
            }
        },

        methods: {
            handleEnter(event){
                this.$emit('keyup',event);
            },
            handleBlur(event) {
                this.$emit('blur', event);
                if(this.validateEvent){
                    this.dispatch('form-item', 'el.form.blur', [this.currentValue]);
                }
            },
            inputSelect() {
                this.$refs.input.select();
            },
            resizeTextarea() {
                if(this.$isServer) return;
                var { autosize, type } = this;
                if (!autosize || type !== 'textarea') {
                    return;
                }
                const minRows = autosize.minRows;
                const maxRows = autosize.maxRows;

                const options = {
                    resize:this.resize
                }

                this.textareaStyle = calcTextareaHeight(this.$refs.textarea, minRows, maxRows,options);
            },
            handleFocus(event) {
                this.$emit('focus', event);
            },
            handleInput(event) {
                this.setCurrentValue(event.target.value);
            },
            handleIconClick(event) {
                if (this.onIconClick) {
                    this.onIconClick(event);
                }
                this.$emit('click', event);
            },
            setCurrentValue(value) {
                if (value === this.currentValue) return;
                this.$nextTick(_ => {
                    this.resizeTextarea();
                });
                this.currentValue = value;
                this.$emit('input', value);
                this.$emit('change', value);
                if (this.validateEvent) {
                    this.dispatch('form-item', 'el.form.change', [value]);
                }
            }
        },

        data() {
            return {
                currentValue: this.value,
                textareaStyle: {}
            };
        },

        created() {
            this.$on('inputSelect', this.inputSelect);
        },

        mounted() {
            this.resizeTextarea();
        },

    };
</script>



// WEBPACK FOOTER //
// src/components/input/src/input.vue